module.exports = __webpack_public_path__ + "static/media/area_proyecto.b8b6d2a2.svg";